export const XL_BREAKPOINT = 'xl'; // 1536px
export const LG_BREAKPOINT = 'lg'; // 1200px
export const MD_BREAKPOINT = 'md'; // 900px
export const SM_BREAKPOINT = 'sm'; // 600px
export const XS_BREAKPOINT = 'xs'; // 06px

export const ACCESS_TOKEN_NAME = 'renewAccessToken';
export const REFRESH_TOKEN_NAME = 'renewRefreshToken';
export const NOTION_NOTIFICATION_URL =
  'https://blockoxyz.notion.site/CCOB-856a8278a46844f3adbbf3b9cc242d33?pvs=4';

// Notion
export const NOTION_API_KEY =
  process.env.REACT_APP_NOTION_API_KEY ||
  'secret_oEHFYhxWUmQfrsW2PzAkmEtVH79iyAkS7B8P1R3Ot9z';
export const NOTION_NOTIFICATION_DATABASE_ID =
  process.env.REACT_APP_NOTION_NOTIFICATION_DATABASE_ID ||
  'b96f4d1f79fe4a8b8e56b164e35f62b6';
export const NOTION_NOTIFICATION_EN_DATABASE_ID =
  process.env.REACT_APP_NOTION_NOTIFICATION_EN_DATABASE_ID ||
  'ce78d83172ea4ad6b3d4c217c2551c7b';

export const FRONT_URL =
  process.env.REACT_APP_FRONT_URL || 'http://localhost:3000';
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://prod-dev.cccv.to';

// GOOGLE
export const GOOGLE_OIDC_AUTH_URL =
  process.env.REACT_APP_GOOGLE_OIDC_AUTH_URL ||
  'https://accounts.google.com/o/oauth2/v2/auth';
export const GOOGLE_OIDC_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_OIDC_CLIENT_ID ||
  '1041725413948-5jernrpkcp85fhnku2rtdc1gce5j3k0b.apps.googleusercontent.com';

// KAKAO
export const KAKAO_JS_KEY =
  process.env.REACT_APP_KAKAO_JS_KEY || 'eef6380e7233d1bc5b9159ffe7715ff8';

//NAVER
export const NAVER_AUTH_URL =
  process.env.REACT_APP_NAVER_AUTH_URL ||
  'https://nid.naver.com/oauth2.0/authorize';
export const NAVER_CLIENT_ID =
  process.env.REACT_APP_NAVER_CLIENT_ID || 'p6qpyWAZmb3w98NJNQb9';

// Policy
export const POLICY_URL =
  'https://www.notion.so/blockoxyz/50636c51e800496fa4901b8dab0d08fb?pvs=4';

// privacy
export const PRIVACY_URL =
  'https://www.notion.so/blockoxyz/d940f81048bf4b09be8839cf857800c4?pvs=4';

// Badge Guide
export const BADGE_GUIDE_URL =
  'https://www.notion.so/blockoxyz/CCCV-97359178ffb94afa9f2e1d610bd81812?pvs=4';

// Badge API Guide
export const BADGE_API_GUIDE_URL =
  'https://www.notion.so/blockoxyz/API-48b4946cbadf4ad6901257f33bfd99e1';

// R2 Bucket Name
export const R2_BUCKET_NAME =
  process.env.REACT_APP_R2_BUCKET_NAME || 'dev-nft-cccv';

// R2 Public URL
export const R2_PUBLIC_DOMAIN =
  process.env.REACT_APP_R2_PUBLIC_DOMAIN || 'https://dev-img.c3v.io';

export const XYZ_MEMBER = [
  'rooney@blocko.io',
  'qqusong@blocko.io',
  'jys9049@blocko.io',
  'marc@blocko.io',
  'sxxbinkim@blocko.io',
];

export const DEV_MODE_COOKIE_NAME = 'CCOB_MOCK_DEV_MODE';

export const IS_PRODUCT =
  process.env.REACT_APP_FRONT_URL === 'https://ccob.cccb.to';

// NAREA PROFILE URL
export const NAREA_PROFILE_URL =
  FRONT_URL.includes('dev') || FRONT_URL.includes('localhost')
    ? process.env.REACT_APP_NAREA_PROFILE_DEV_URL ||
      'https://dev.nft.cccv.to/set/user'
    : process.env.REACT_APP_NAREA_PROFILE_URL || 'https://nft.cccv.to/set/user';

export const AERGO_SCAN_URL =
  process.env.REACT_APP_AERGO_SCAN_URL ||
  'https://scan.xyznode.io/transaction/';

export const BADGE_GIFT_LINK = process.env.REACT_APP_BADGE_GIFT_LINK || '';
